import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["readonly", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("textarea", {
    class: "w-full border px-3 py-2 font-mono text-sm focus:outline-none resize-y bg-gray-200 whitespace-pre-wrap border-gray-300 text-gray-800 dark:text-dark-text dark:border-dark-200 dark:bg-dark-400",
    readonly: !_ctx.isEditable,
    style: _normalizeStyle(`height: ${_ctx.height}px; border-radius: 0.5rem`),
    value: _ctx.value,
    wrap: "off",
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeText && _ctx.changeText(...args)))
  }, null, 44, _hoisted_1))
}